import Axios from 'axios'

Axios.defaults.timeout = 15000;

/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
        params: params,
        headers: headers
      })
      .then(response => {
          resolve(response.data); 
      })
      .catch(err => {
        reject(err);
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, headers = {}) {
  return new Promise((resolve, reject) => {
    Axios({
      method: "post",
      url,
      data: data,
      headers: headers
    }).then(response => {
        resolve(response.data);
    }, err => {
      reject(err)
    });
  })
}